import dayjs from 'dayjs';

/** "HH:mm - HH:mm" */
export function formatTimeRange(
	fromDate: string | Date,
	toDate: string | Date
): string {
	return `${dayjs(fromDate).format('HH:mm')} - ${dayjs(toDate).format(
		'HH:mm'
	)}`;
}
